import { render, staticRenderFns } from "./UserColorsResetModal.vue?vue&type=template&id=4ee6bac2&"
import script from "./UserColorsResetModal.vue?vue&type=script&lang=js&"
export * from "./UserColorsResetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports